var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4802_1254)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 2.5,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9996 32.9996C25.8007 32.9996 25.6099 32.9206 25.4693 32.7799C25.3286 32.6393 25.2496 32.4485 25.2496 32.2496L25.2496 17.5599L19.7802 23.0302C19.7105 23.0999 19.6278 23.1552 19.5368 23.1929C19.4457 23.2306 19.3481 23.25 19.2496 23.25C19.151 23.25 19.0535 23.2306 18.9624 23.1929C18.8714 23.1552 18.7886 23.0999 18.719 23.0302C18.6493 22.9606 18.594 22.8778 18.5563 22.7868C18.5186 22.6957 18.4992 22.5982 18.4992 22.4996C18.4992 22.4011 18.5186 22.3035 18.5563 22.2124C18.594 22.1214 18.6493 22.0387 18.719 21.969L25.469 15.219C25.5386 15.1493 25.6213 15.0939 25.7124 15.0562C25.8034 15.0185 25.901 14.999 25.9996 14.999C26.0981 14.999 26.1957 15.0185 26.2868 15.0562C26.3778 15.0939 26.4606 15.1493 26.5302 15.219L33.2802 21.969C33.4209 22.1097 33.5 22.3006 33.5 22.4996C33.5 22.6986 33.4209 22.8895 33.2802 23.0302C33.1395 23.171 32.9486 23.25 32.7496 23.25C32.5506 23.25 32.3597 23.171 32.219 23.0302L26.7496 17.5599L26.7496 32.2496C26.7496 32.4485 26.6706 32.6393 26.5299 32.7799C26.3893 32.9206 26.1985 32.9996 25.9996 32.9996Z",
    fill: "#117C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 33H33",
    stroke: "#117C57",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4802_1254",
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4802_1254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4802_1254",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/Paid.5f152ba4e3f4af57d7e5542fcc044398.svg";
export { ForwardRef as ReactComponent };